import { useQuery } from '@tanstack/react-query';
import type { UserDto } from '@time-tracking/shared';

import { parseJson } from './client.js';
import { useApiFetch } from './useApiFetch.js';

export function useSearchUsers(q: string, options?: { allowEmpty?: boolean }) {
  const fetch = useApiFetch();
  return useQuery<UserDto[]>({
    queryKey: ['users', 'search', q],
    queryFn: () =>
      fetch(`/v1/users?q=${encodeURIComponent(q)}`).then((r) => parseJson<UserDto[]>(r)),
    enabled: q.trim().length >= 1 || (options?.allowEmpty ?? false),
    staleTime: 30_000,
  });
}
